import { useQuery } from "@tanstack/react-query";

const BASE = process.env.REACT_APP_BACKEND_URL;

/** Brand / entity settings managed in CRM → SEO & Google. */
export const useSeoSettings = () => {
    const { data } = useQuery({
        queryKey: ["seo-settings"],
        queryFn: async () => {
            const res = await fetch(`${BASE}/api/seo/settings`);
            if (!res.ok) throw new Error("seo settings");
            return res.json();
        },
        staleTime: 10 * 60 * 1000,
    });
    return data || {};
};

export const fetchRedirects = async () => {
    const res = await fetch(`${BASE}/api/seo/redirects`);
    if (!res.ok) return { rules: [] };
    return res.json();
};
